var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"px-2"},[_c('TimeseriesTable',{attrs:{"loading":_vm.tableQuery.loading,"items":_vm.tableQuery.items,"items-per-page":5,"columns":_vm.tableQuery.columns,"order":_vm.tableQuery.order,"axios-params":_vm.tableQuery.axiosParams}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }